import type { App } from 'vue'

export function useEnter(app: App) {
    app.directive('enter', {
        mounted(el, binding) {
            el &&
                el.addEventListener('animationend', () => {
                    binding.value && binding.value()
                })
        },
    })
}
